import instanceQuery from 'graphql/queries/salesLedger/SalesCreditPostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const SalesCreditPostingPreview = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default SalesCreditPostingPreview;
